import { useEffect, useState } from 'react';
import { api } from '../api/client';
import { calendarTabFor, onCalendarPrefs } from '../utils/calendarPrefsEvent';

/**
 * The Tasks page tab the calendar opens on (Settings > Calendar > Default view). Read when the
 * person is known, and (decision 9d) updated the moment Settings saves a change, with no reload.
 * null until the first read answers; 'week' if that read fails (the behaviour App.js always had).
 */
export function useCalendarDefaultTab(userId) {
  const [tab, setTab] = useState(null);

  useEffect(() => {
    if (!userId) return undefined;
    let alive = true;
    api('/api/calendar/preferences')
      .then((r) => r.json())
      .then((d) => { if (alive) setTab(calendarTabFor(d && d.defaultView)); })
      .catch(() => { if (alive) setTab('week'); });
    const off = onCalendarPrefs((d) => setTab(calendarTabFor(d.defaultView)));
    return () => { alive = false; off(); };
  }, [userId]);

  return tab;
}
